import UrlServices from "./Url";

export const SUBMIT_FAILED_MESSAGE =
  "We couldn't send your request. Please try again.";

// RB-19754: both submit paths (Cart, and the mobile buttons in AppManager) post
// through here so one guard covers them — a second press while a request is
// being sent is ignored instead of becoming a second lead.
let inFlight = false;

export const isSubmittingLead = () => inFlight;

// One id per booking, reused on retries, so the backend can recognise a
// request it has already saved and return that lead instead of a new one.
export const newSubmissionId = () =>
  window.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

// Resolves to { ok: true } only when the lead was saved, otherwise to
// { ok: false, message } with a message fit to show the customer.
export const submitLead = async (data) => {
  inFlight = true;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_APPOINTMENT_PRO_API_URL}/${UrlServices.submitRequest}`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );
    if (res.ok) return { ok: true };
    const body = await res.json().catch(() => null);
    const message =
      res.status < 500 && typeof body?.message === "string" && body.message;
    return { ok: false, message: message || SUBMIT_FAILED_MESSAGE };
  } catch (error) {
    console.log(error);
    return { ok: false, message: SUBMIT_FAILED_MESSAGE };
  } finally {
    inFlight = false;
  }
};
